import './TimePeriodToggle.scss';

import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { useTranslation } from 'src/i18n';

export type TimePeriod = '24hours' | '1week';

interface TimePeriodToggleProps {
  value: TimePeriod;
  onChange: (period: TimePeriod) => void;
  tooltip?: string;
}

export default function TimePeriodToggle (props: TimePeriodToggleProps) {
  const { value, onChange, tooltip } = props;
  const { t } = useTranslation();

  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: TimePeriod | null) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  const toggleGroup = (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="medium"
      className="time-period-toggle-group"
    >
      <ToggleButton value="24hours" aria-label="24 hours">
        {t('commLoops.timePeriod24Hours')}
      </ToggleButton>
      <ToggleButton value="1week" aria-label="1 week">
        {t('commLoops.timePeriod1Week')}
      </ToggleButton>
    </ToggleButtonGroup>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <div className="time-period-toggle-wrapper">
          {toggleGroup}
        </div>
      </Tooltip>
    );
  }

  return (
    <div className="time-period-toggle-wrapper">
      {toggleGroup}
    </div>
  );
}

TimePeriodToggle.propTypes = {
  value: PropTypes.oneOf(['24hours', '1week']).isRequired,
  onChange: PropTypes.func.isRequired,
  tooltip: PropTypes.string
};

TimePeriodToggle.defaultProps = {
  tooltip: undefined
};
